<template>
  <div class="evaluate-list" ref="container">
    <nav-bar
        fixed
        z-index="99"
        title="评价"
        left-text="返回"
        left-arrow
        @click-left="handleBackNavigation"
    />
    <div style="height: 46px"></div>
    <div style="height: 10px"></div>
    <UserEvaluation :reply="reply"></UserEvaluation>
  </div>
</template>
<script>
import UserEvaluation from "@components/UserEvaluation";
import { NavBar } from "vant";
import { orderDetail } from "@api/order";

export default {
  name: "OrderEvaluate",
  components: {
    UserEvaluation,
    NavBar
  },
  props: {},
  data: function () {
    return {
      reply: [],
      isFromInvitation: false,
    };
  },
  mounted: function () {
    this.getDetail();
    // 检查是否来自邀请链接
    this.isFromInvitation = this.$route.query.from === 'invitation';
  },
  activated() {
    // 检查是否来自邀请链接
    this.isFromInvitation = this.$route.query.from === 'invitation';
  },
  methods: {
    // 处理返回导航
    handleBackNavigation() {
      if (this.isFromInvitation) {
        // 如果是从邀请链接进入，返回个人中心
        this.$router.push('/user');
      } else {
        // 否则返回订单列表
        this.$router.push({
          path: '/order/list',
          query: { userCategory: this.$route.query.userCategory || 1 }
        });
      }
    },
    getDetail() {
      orderDetail(this.$route.params.id, {
        userCategory: this.$route.query.userCategory,
      })
          .then((res) => {
            this.reply = res.data.productReplyList.map(item=>{
              item.nickname = res.data.lcUser.nickname;
              item.avatar = res.data.lcUser.avatar;
              return item;
            });
          })
          .catch((err) => {
            this.$dialog.error(err.msg);
          });
    },
  },
};
</script>
<style scoped>
.noCommodity {
  height: 8rem;
  background-color: #fff;
}
</style>
